"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeReducer = void 0;
var tslib_1 = require("tslib");
var ui_symbols_1 = require("@hopin-team/ui-symbols");
var lodash_merge_1 = tslib_1.__importDefault(require("lodash.merge"));
var themeActions_1 = require("./themeActions");
var themeReducer = function (state, action) {
    switch (action.type) {
        case themeActions_1.THEME_ACTIONS.LOADED_SET:
            return tslib_1.__assign(tslib_1.__assign({}, state), { isThemeLoaded: true });
        case themeActions_1.THEME_ACTIONS.CUSTOM_THEME_SET:
            return tslib_1.__assign(tslib_1.__assign({}, state), { currentTheme: (0, lodash_merge_1.default)({}, ui_symbols_1.rcTheme, action.payload.newTheme) });
        case themeActions_1.THEME_ACTIONS.CUSTOM_FONT_SET:
            return tslib_1.__assign(tslib_1.__assign({}, state), { fontUrls: tslib_1.__assign(tslib_1.__assign({}, state.fontUrls), action.payload.newFonts) });
        default:
            return tslib_1.__assign({}, state);
    }
};
exports.themeReducer = themeReducer;
//# sourceMappingURL=themeReducer.js.map